<!-- eslint-disable vue/no-v-html -->
<template>
  <router-link :to="`/faq/${slug}-${id}`" data-testid="faq-card-link" class="faq-card">
    <div class="card-section">
      <BlTextAv variation="subheading-18" :ellipsis="1" data-testid="faq-card-title">{{ title }}</BlTextAv>
      <p
        variation="body-14"
        data-testid="faq-card-summary"
        class="mt-16 mt-16 bl-text bl-text--subdued bl-text--ellipsis-2 summary-text"
        v-html="formatHtml(summary)"
      />
    </div>
    <div>
      <BlIconAv name="ico_chevron_right_minor" />
    </div>
  </router-link>
</template>

<script>
import {BlIconAv} from '@bukalapak/bazaar-visual';
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import xss from 'xss';

export default {
  name: 'FaqCard',
  components: {
    BlIconAv,
    BlTextAv,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    summary: {
      type: String,
      required: true,
    },
  },
  methods: {
    formatHtml(html) {
      return xss(html);
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-card {
  padding: 16px 32px;
  border: 1px solid #d6d6d6;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  text-decoration: none;
}
.card-section {
  width: 90%;
}
.summary-text {
  max-width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
}
</style>
